import { Api } from "./Api";
import { config } from "@/config";
import { waitFor } from "xstate";
import { authMachine } from "@/machines/auth-machine";

export async function WithoutBearer(forContent = false): Promise<Api> {
  await waitFor(authMachine, (state) => state.matches("authenticated"));
  return new Api({ apiUrl: forContent ? config.contentUrl : config.apiUrl, feature: false }, false);
}
export async function WithBearer(): Promise<Api> {
  await waitFor(authMachine, (state) => state.matches("authenticated"));
  return new Api({ apiUrl: config.apiUrl, feature: false }, true);
}

export async function FeatuerWithBearer(): Promise<Api> {
  await waitFor(authMachine, (state) => state.matches("authenticated"));
  return new Api({ apiUrl: config.apiUrl, feature: true }, true);
}
